import { CameraPreset } from './camera.types';
import { ShotData } from './shot.types';

/**
 * Response from the Dynamic Director API
 * Contains camera position and shots to display
 */
export interface DirectorResponse {
  cameraPreset: CameraPreset | null;
  shots: ShotData[];
  timestamp: number;
}

/**
 * Types of events that can be queued
 */
export enum EventType {
  CAMERA_MOVE = 'CAMERA_MOVE',
  SHOT_TRACE = 'SHOT_TRACE',
}

/**
 * Event to be processed by the event queue
 */
export interface DirectorEvent {
  id: string;
  type: EventType;
  payload: CameraPreset | ShotData;
  onComplete?: () => void;
}

/**
 * State of the event queue
 */
export interface QueueState {
  queue: DirectorEvent[];
  currentEvent: DirectorEvent | null;
  isBusy: boolean;
}
